import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import axios from "axios";

const ClassPassCard = () => {
  const { route, class_id } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const logo = decodeToken(token, "logo");
  const user_id = decodeToken(token, "id");
  const [data, setData] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${route}`;
    const fetchData = async () => {
      try {
        const response = await axios.post(
          url,
          { class_id, user_id },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : "",
            },
          }
        );
        setData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [route, class_id, user_id, token]);

  useEffect(() => {
    if (data.length > 0) {
      console.log("data: ", data);
      setTimeout(() => {
        window.print();
      }, 800);
    }
  }, [data]);

  if (data.length <= 0) return null;

  const groupIntoFours = (arr) => {
    const groups = [];
    for (let i = 0; i < arr.length; i += 4) {
      groups.push(arr.slice(i, i + 4));
    }
    return groups;
  };

  const groupedData = groupIntoFours(data);

  return (
    <div>
      <style>
        {`
          

          .page {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            justify-content: center;
            align-items: start;
            gap: 20px;
            page-break-after: always;
            padding: 10px 20px;
            box-sizing: border-box;
          }

          .card {
            border: 1px solid #000;
            border-radius: 15px;
            background: #fff;
            padding: 10px 12px;
            height: 370px; /* Reduced for landscape */
            width: 100%;
            box-sizing: border-box;
            font-family: Arial, sans-serif;
            position: relative;
            box-shadow: 0 0 3px rgba(0,0,0,0.15);
          }
        `}
      </style>

      {groupedData.map((page, pageIndex) => (
        <div key={pageIndex} className="page">
          {page.map((student, index) => (
            <div key={index} className="card">
              <center>
                <img
                  src={`${API_URL}/${banner}`}
                  alt="Banner"
                  width="100%"
                  height="60"
                  style={{ borderRadius: "30px" }}
                />
              </center>

              <h5
                style={{
                  marginTop: "10px",
                  textTransform: "uppercase",
                  fontWeight: 700,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color: "#05259c",
                  fontSize: "14px",
                }}
              >
                <span>{student._academic_year}</span>
                <span>{student._title}</span>
                <span>{student._exam_type}</span>
              </h5>

               <hr />
            <br />
              
            <div style={{display:"flex",justifyContent:"space-between"}}>
              <div style={{ fontSize: "17px", color: "black", lineHeight: "1.3" }}>
                {Object.entries(student)
                  .filter(([key]) => !key.startsWith("_"))
                  .map(([key, value]) => (
                    <p key={key} style={{ marginBottom: "4px", color: "black" }}>
                      {key}: <strong>{value}</strong>
                    </p>
                  ))}
              </div>
              <img
                src={`${API_URL}/${student._photo}`}
                alt="Student"
                style={{
                  width: "100px",
                  height: "100px",
                  marginTop: "-10px",
                  marginRight: "10px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
               <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", 
    marginLeft: "50%",         
    marginTop: "-150px"
  }}
>
  <div
    style={{
      width: "230px",
      height: "160px",
      border: "3px solid grey",
      padding: "10px",
      boxSizing: "border-box",
      fontWeight: "bold",
      backgroundColor: "#fff",
    }}
  >
    <p style={{ marginTop: "85px", fontSize: "1.0rem" }}>
      Signature: ___________
    </p>
    <br />

  <div
    style={{
      textAlign: "center",
      fontWeight: "normal",
      whiteSpace: "nowrap",  
    }}
  >
    {student?._description}
  </div>
  </div>

  
</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ClassPassCard;
